import { withStyles } from '@material-ui/core';

import Archive from './component';
import styles from './styles';

export default withStyles(styles)(Archive);
